var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutoAwesomeGradientIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.5L15 10L12.5 15.5L7 18L12.5 20.5L15 26L17.5 20.5L23 18L17.5 15.5ZM15.99 18.99L15 21.17L14.01 18.99L11.83 18L14.01 17.01L15 14.83L15.99 17.01L18.17 18L15.99 18.99Z",
  fill: "url(#paint0_linear_16480_109774)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 21L23.75 23.75L21 25L23.75 26.25L25 29L26.25 26.25L29 25L26.25 23.75L25 21Z",
  fill: "url(#paint1_linear_16480_109774)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 15L26.25 12.25L29 11L26.25 9.75L25 7L23.75 9.75L21 11L23.75 12.25L25 15Z",
  fill: "url(#paint2_linear_16480_109774)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_16480_109774",
  x1: 18,
  y1: 7,
  x2: 18,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A26CE8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#24A3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_16480_109774",
  x1: 18,
  y1: 7,
  x2: 18,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A26CE8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#24A3E4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_16480_109774",
  x1: 18,
  y1: 7,
  x2: 18,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A26CE8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#24A3E4"
})))));
export { SvgAutoAwesomeGradientIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUgMTUuNUwxNSAxMEwxMi41IDE1LjVMNyAxOEwxMi41IDIwLjVMMTUgMjZMMTcuNSAyMC41TDIzIDE4TDE3LjUgMTUuNVpNMTUuOTkgMTguOTlMMTUgMjEuMTdMMTQuMDEgMTguOTlMMTEuODMgMThMMTQuMDEgMTcuMDFMMTUgMTQuODNMMTUuOTkgMTcuMDFMMTguMTcgMThMMTUuOTkgMTguOTlaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTY0ODBfMTA5Nzc0KSIvPgo8cGF0aCBkPSJNMjUgMjFMMjMuNzUgMjMuNzVMMjEgMjVMMjMuNzUgMjYuMjVMMjUgMjlMMjYuMjUgMjYuMjVMMjkgMjVMMjYuMjUgMjMuNzVMMjUgMjFaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfMTY0ODBfMTA5Nzc0KSIvPgo8cGF0aCBkPSJNMjUgMTVMMjYuMjUgMTIuMjVMMjkgMTFMMjYuMjUgOS43NUwyNSA3TDIzLjc1IDkuNzVMMjEgMTFMMjMuNzUgMTIuMjVMMjUgMTVaIiBmaWxsPSJ1cmwoI3BhaW50Ml9saW5lYXJfMTY0ODBfMTA5Nzc0KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE2NDgwXzEwOTc3NCIgeDE9IjE4IiB5MT0iNyIgeDI9IjE4IiB5Mj0iMjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0EyNkNFOCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNEEzRTQiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzE2NDgwXzEwOTc3NCIgeDE9IjE4IiB5MT0iNyIgeDI9IjE4IiB5Mj0iMjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0EyNkNFOCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNEEzRTQiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDJfbGluZWFyXzE2NDgwXzEwOTc3NCIgeDE9IjE4IiB5MT0iNyIgeDI9IjE4IiB5Mj0iMjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0EyNkNFOCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNEEzRTQiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";